export default "__VITE_ASSET__BPQf9KWi__"